export const textColor = [
  "text-transparent",
  "text-black",
  "text-white",
  "text-gray-50",
  "text-gray-100",
  "text-gray-200",
  "text-gray-300",
  "text-gray-400",
  "text-gray-500",
  "text-gray-600",
  "text-gray-700",
  "text-gray-800",
  "text-gray-900",

  "text-red-50",
  "text-red-100",
  "text-red-200",
  "text-red-300",
  "text-red-400",
  "text-red-500",
  "text-red-600",
  "text-red-700",
  "text-red-800",
  "text-red-900",

  "text-yellow-50",
  "text-yellow-100",
  "text-yellow-200",
  "text-yellow-300",
  "text-yellow-400",
  "text-yellow-500",
  "text-yellow-600",
  "text-yellow-700",
  "text-yellow-800",
  "text-yellow-900",

  "text-green-50",
  "text-green-100",
  "text-green-200",
  "text-green-300",
  "text-green-400",
  "text-green-500",
  "text-green-600",
  "text-green-700",
  "text-green-800",
  "text-green-900",

  "text-blue-50",
  "text-blue-100",
  "text-blue-200",
  "text-blue-300",
  "text-blue-400",
  "text-blue-500",
  "text-blue-600",
  "text-blue-700",
  "text-blue-800",
  "text-blue-900",

  "text-indigo-50",
  "text-indigo-100",
  "text-indigo-200",
  "text-indigo-300",
  "text-indigo-400",
  "text-indigo-500",
  "text-indigo-600",
  "text-indigo-700",
  "text-indigo-800",
  "text-indigo-900",

  "text-purple-50",
  "text-purple-100",
  "text-purple-200",
  "text-purple-300",
  "text-purple-400",
  "text-purple-500",
  "text-purple-600",
  "text-purple-700",
  "text-purple-800",
  "text-purple-900",

  "text-pink-50",
  "text-pink-100",
  "text-pink-200",
  "text-pink-300",
  "text-pink-400",
  "text-pink-500",
  "text-pink-600",
  "text-pink-700",
  "text-pink-800",
  "text-pink-900",
];

export const textAlignment = [
  "text-left",
  "text-center",
  "text-right",
  "text-justify",
];

export const textOpacity = [
  "text-opacity-0",
  "text-opacity-5",
  "text-opacity-10",
  "text-opacity-20",
  "text-opacity-25",
  "text-opacity-30",
  "text-opacity-40",
  "text-opacity-50",
  "text-opacity-60",
  "text-opacity-70",
  "text-opacity-75",
  "text-opacity-80",
  "text-opacity-90",
  "text-opacity-95",
  "text-opacity-100",
];

export const textDecoration = ["underline", "line-through", "no-underline"];

export const textTransformation = [
  "uppercase",
  "lowercase",
  "capitalize",
  "normal-case",
];

export const textOverflow = ["truncate", "overflow-ellipsis", "overflow-clip"];

export const textFontSize = [
  "text-xs",
  "text-sm",
  "text-base",
  "text-lg",
  "text-xl",
  "text-2xl",
  "text-3xl",
  "text-4xl",
  "text-5xl",
  "text-6xl",
  "text-7xl",
  "text-8xl",
  "text-9xl",
];

export const fontWeight = [
  "font-thin",
  "font-extralight",
  "font-light",
  "font-normal",
  "font-medium",
  "font-semibold",
  "font-bold",
  "font-extrabold",
  "font-black",
];

export const fontVariant = [
  "normal-nums",
  "ordinal",
  "slashed-zero",
  "lining-nums",
  "oldstyle-nums",
  "proportional-nums",
  "tabular-nums",
  "diagonal-fractions",
  "stacked-fractions",
];

export const letterSpacing = [
  "tracking-tighter",
  "tracking-tight",
  "tracking-normal",
  "tracking-wide",
  "tracking-wider",
  "tracking-widest",
];

export const lineHeight = [
  "leading-3",
  "leading-4",
  "leading-5",
  "leading-6",
  "leading-7",
  "leading-8",
  "leading-9",
  "leading-10",
  "leading-none",
  "leading-tight",
  "leading-snug",
  "leading-normal",
  "leading-relaxed",
  "leading-loose",
];

export const verticalAlign = [
  "align-baseline",
  "align-top",
  "align-middle",
  "align-bottom",
  "align-text-top",
  "align-text-bottom",
];

export const wordBreak = ["break-normal", "break-words", "break-all"];
export const tableBorder = ["border-collapse", "border-separate"];
export const tableLayout = ["table-auto", "table-fixed"];

export const backgroundAttachment = ["bg-fixed", "bg-local", "bg-scroll"];
export const backgroundClip = [
  "bg-clip-border",
  "bg-clip-padding",
  "bg-clip-content",
  "bg-clip-text",
];

export const bgColor = [
  "bg-transparent",
  "bg-black",
  "bg-white",
  "bg-gray-400",
  "bg-gray-700",
  "bg-red-400",
  "bg-red-700",
  "bg-yellow-400",
  "bg-yellow-700",
  "bg-green-400",
  "bg-green-700",
  "bg-blue-400",
  "bg-blue-700",
  "bg-indigo-400",
  "bg-indigo-700",
  "bg-purple-400",
  "bg-purple-700",
  "bg-pink-400",
  "bg-pink-700",
];

export const bgRepeat = [
  "bg-repeat",
  "bg-no-repeat",
  "bg-repeat-x",
  "bg-repeat-y",
  "bg-repeat-round",
  "bg-repeat-space",
];

export const bgSize = ["bg-auto", "bg-cover", "bg-contain"];

export const borderRadius = [
  "rounded-none",
  "rounded",
  "rounded-lg",
  "rounded-full",
];

export const borderWidth = [
  "border-0",
  "border-4",
  "border",
  "border-t-4",
  "border-r-4",
  "border-l-4",
  "border-b-4",
];

export const borderColor = [
  "border-black",
  "border-gray-500",
  "border-red-500",
  "border-yellow-500",
  "border-green-500",
  "border-blue-500",
  "border-indigo-500",
  "border-purple-500",
  "border-pink-500",
];

export const borderStyle = [
  "border-solid",
  "border-dashed",
  "border-dotted",
  "border-double",
  "border-none",
];
